module.exports = __webpack_public_path__ + "img/partnered-solutions.c01e36b4.png";